import React, { useEffect, useState, useRef, useContext } from 'react';
import {IProps, IState} from './types';
import { useSelector } from 'react-redux';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import * as S from './styles';
import selectors from '@state/selectors';
import { getLabelsFromSection } from '@utils/brand';
import DeleteIcon from '@assets/icons/deleteIcon';
import EditIcon from '@assets/icons/editIcon';
import { IActionInfo, IElementUpdate } from '@state/brands/types';

const RightClickMenu:React.FC<IProps> = (props) => {
  const authContext = useContext(AuthContext);

  const [coordinates, setCoordinates] = useState({x: 0, y:0});
  const [counters, setCounters] = useState({templates: 0, designs: 0});
  const [selectedItems, setSelectedItems] = useState<any[]>([]);

  const addUpdateResponse = useSelector(selectors.brands.getAddUpdateBrand);

  useEffect(() => {
    if (props.open) setCoordinates(props.coordinates);
  }, [props.open]);

  useEffect(() => {
    if (addUpdateResponse || props.items?.length) {
      handleCloseWarning();
    }
  }, [addUpdateResponse, props.items?.length]);

  useEffect(() => {
    if (props.selectedIndexes.length > 0) {
      setCoordinates(props.coordinates);
      let newCounters = {templates: 0, designs: 0};
      let newSelectedItems: any[] = [];
      props.selectedIndexes.map(selectedIndex => {
        const item = props.items[selectedIndex];
        if (item) {
          newSelectedItems = [...newSelectedItems, item];
          if (item.templatesCount && item.designsCount) {
            newCounters.templates += item.templatesCount;
            newCounters.designs += item.designsCount;
          }
        }
      });
      setCounters(newCounters);
      setSelectedItems(newSelectedItems);
    } else {
      setSelectedItems([]);
      setCounters({templates: 0, designs: 0});
    }
  }, [props.selectedIndexes]);

  const elementName = getLabelsFromSection(props.section);
  const sValue = props.selectedIndexes.length > 1 ? `s` : ``;

  const handleDelete = () => {

    let title = `Delete ${elementName}${sValue}`
    let subtitle = `Are you sure you want to delete these items? If you delete these items, ${counters.templates} template${sValue} and ${counters.designs} design${sValue} files will reflect this change.`
    if (props.section == "Templates" && props.deleteTemplates)
      props.deleteTemplates(selectedItems, props.selectedIndexes);
    else{
      props.handleWarningScreen(
        true, title,subtitle,
        "CANCEL",  () => {handleFinishDelete()}, "DELETE", "", []
      );
    }
  }

  const handleCloseWarning = () => {
    props.handleWarningScreen(false, ``, ``, "", undefined, "", "", []);
  };

  const handleFinishDelete = () => {
    if (selectedItems.length > 0) {
      props.handleWarningScreen(
        true, `Delete ${elementName}${sValue}`,
        `Are you sure you want to delete these items? If you delete these items, ${counters.templates} template${sValue} and ${counters.designs} design${sValue} files will reflect this change.`,
        "CANCEL", undefined, "DELETING...", "", []
      );
      let updadeInfoItems: IElementUpdate[] = [];
      selectedItems.map(selectedItem => {
        if (props.section !== "colors" && props.moveFile) props.moveFile(selectedItem.srcImage, selectedItem.format);
        let element: any  = {...selectedItem};
        let newAction : IActionInfo = {
          user: {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
          },
          date: new Date(),
          action:"DELETE"
        }
        element.actions.push({...newAction});
        element.status = "INACTIVE";
        let updateInfo : IElementUpdate = {
          action: "DELETE", //INSERT DELETE UPDATE
          field: props.section?.toUpperCase() ?? 'LOGOS',
          value: element
        }
        updadeInfoItems = [...updadeInfoItems, updateInfo];
      });
      if (props.addUpdateBrand)
        props.addUpdateBrand(updadeInfoItems, undefined, undefined, undefined, undefined, `${selectedItems.length} ${props.section==="colors" ? 'color' : 'file'}${selectedItems.length>1 ? 's':''} deleted.`);
    } else {
      handleCloseWarning();
    }
  }

  const handleEditStatus = () => {
    props.setOpen(false);
    if (props.onActionsTemplate) props.onActionsTemplate("EDIT", selectedItems, 0);
  }


  return (
    <S.Root>
      {
        (props.selectedIndexes.length > 0 && !props.open) &&
        <S.AuxText
          xValue={coordinates.x}
          yValue={coordinates.y}
        >
          Right click to see options
        </S.AuxText>
      }
      {
        (props.selectedIndexes.length > 0 && props.open) &&
        <S.MenuContainer
          xValue={coordinates.x}
          yValue={coordinates.y}
        >
          <S.MenuTitle>
            {`${props.selectedIndexes.length} Item${sValue}`}
          </S.MenuTitle>
          <S.MenuSubtitle>
            {`${elementName}s`}
          </S.MenuSubtitle>
          {
            props.section === "Templates" &&
            <S.MenuActionContainer>
              <S.MenuActionRow
                onClick={handleEditStatus}
              >
                <S.MenuActionIcon>
                  <EditIcon />
                </S.MenuActionIcon>
                <S.MenuAactionText>
                  {`Edit Tags & Status`}
                </S.MenuAactionText>
              </S.MenuActionRow>
            </S.MenuActionContainer>
          }
          <S.MenuDivider />
          <S.MenuActionContainer>
            <S.MenuActionRow
              onClick={handleDelete}
            >
              <S.MenuActionIcon>
                <DeleteIcon />
              </S.MenuActionIcon>
              <S.MenuAactionText>
                {`Delete ${elementName}${sValue}`}
              </S.MenuAactionText>
            </S.MenuActionRow>
          </S.MenuActionContainer>
        </S.MenuContainer>
      }
    </S.Root>
  );
}

export default RightClickMenu;